export default __webpack_public_path__ + "static/media/digit_span_male_1.fa222ae1.png";